// extracted by mini-css-extract-plugin
module.exports = {"quickFilter":"+nr3k","icon":"aep6c"};